"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CustomerPeriodModel {
    constructor(cache) {
        this.key = (customerId) => `MOCK_CUSTOMER_PERIODS.${customerId}`;
        this.setPeriods = (periods, customerId) => {
            return this.cache.setArray(this.key(customerId), periods).asPromise();
        };
        this.getPeriods = (customerId) => {
            return this.cache
                .getArray(this.key(customerId))
                .withDefault([])
                .asPromise();
        };
        this.cache = cache;
    }
}
exports.default = CustomerPeriodModel;
//# sourceMappingURL=CustomerPeriodModel.js.map